import thunk from 'redux-thunk';
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { getLegacyStore } from '@beef/legacy-beeline-store';
import { authorization } from '@beef/layout-kit/store';
import { analytics } from '@beef/shop-common';

import { cookieObserverMiddleware, cookieObserverReducer } from 'utils/redux';
import tradeIn from 'store/common/tradeIn/reducers';
import { specialProjectHeader } from 'store/common/specialProjectHeader';

import basketReducers from './common/basket/reducers';
import notifyReducers from './common/notify/reducers';
import settingsReducers from './common/settings/reducers';
import abReducers from './common/ab/reducers';
import modalReducers from './common/modal/reducer';
import { localStorageMiddleware, setOriginCookieMiddleware } from './middlewares';
import EULA from './common/EULA/reducers';
import { recommendations } from './common/recommendations/reducers';

/**
 * Common reducer can be used as as to render a common page, or extended in page
 */
export const commonRootReducers = {
  header: (state = {}) => ({
    ...state,
  }),
  specialProjectHeader,
  footer: (state = {}) => state,
  body: (state = {}) => state,
  widgets: (state = {}) => state,
  settings: (state = {}) => state,
  common: combineReducers({
    settings: settingsReducers,
    basket: basketReducers,
    notify: notifyReducers,
    ab: abReducers,
    modal: modalReducers,
    recommendations,
  }),
  form: formReducer,
  cookieHash: cookieObserverReducer,
  EULA,
  tradeIn,
  analytics,
};

/**
 * Project wide typical redux store
 * has three arguments, neither of which are required
 */
export function configureStore(initialState, rootReducer, extraMiddleware) {
  rootReducer = rootReducer || combineReducers(commonRootReducers);
  const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    rootReducer,
    initialState || {},
    composeEnhancers(
      applyMiddleware(
        cookieObserverMiddleware,
        thunk,
        localStorageMiddleware,
        setOriginCookieMiddleware,
        ...(extraMiddleware || []),
      ),
    ),
  );

  // TODO: restore hot reload for reducers
  // if (process.env.NODE_ENV !== 'production') {
  //   if (module.hot) {
  //     module.hot.accept(reducerPath, () => {
  //       this.store.replaceReducer(rootReducer);
  //     });
  //   }
  // }
}

/**
 * This hack is required in order to make LayoutHeader work
 * you should not use default export in project elsewhere
 */
const globalStore = getLegacyStore();

if (typeof window !== 'undefined') {
  window.beeline = window.beeline || {};
  window.beeline.store = window.beeline.store || globalStore;
}
globalStore.addReducer(authorization);

/** @deprecated */
export default globalStore;
